<template>
  <div class="switch-status">
    <span> {{ title }} </span>
    <span class="switch-group">
      <span v-for="seriesIndex in seriesIndexList" :key="seriesIndex" class="value-span"
        :class="{ 'warning-flag': sta(seriesList[seriesIndex]), 'error-flag': staError(seriesList[seriesIndex]) }">
        {{ switchText(seriesList[seriesIndex]) }}
      </span>
    </span>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: "switch-status",
  props: {
    title: {
      type: String,
      required: true,
    },
    series: {
      type: [Object, Array],
      required: false,
    },
  },
  computed: {
    seriesList() {
      if (this.series instanceof Array) {
        return this.series;
      } else {
        return [this.series];
      }
    },
    seriesIndexList() {
      let result = [];
      if (!this.seriesList) {
        return result;
      }

      for (let i = 0; i < this.seriesList.length; i++) {
        result.push(i);
      }
      return result;
    },
  },
  methods: {
    sta(seriesItem) {
      return !seriesItem || seriesItem.data === undefined || seriesItem.data === null || seriesItem.data === "--";
    },
    staError(seriesItem) {
      return !this.sta(seriesItem) && seriesItem.isError === "Error";
    },
    switchText(seriesItem) {
      if (!seriesItem) {
        return "";
      }
      if (seriesItem.isRunningTime === true) {
        return this.translateTime(seriesItem);
      }

      let result = "";
      if (seriesItem.name) {
        result = seriesItem.name + " ";
      }

      if (seriesItem.data || seriesItem.data === 0) {
        let data = seriesItem.data;
        if(Number(data)){
          data = parseFloat(Number(data).toFixed(2));
        }
        result = result + data;
      } else {
        result = result + "--";
      }

      if (seriesItem.unit) {
        result = result + " " + seriesItem.unit;
      }

      return result;
    },
    translateTime(seriesItem) {
      if (seriesItem.isRunningTime !== true) {
        return "不适用";
      }
      let day = Number(seriesItem.data) / 60 / 24;
      if (seriesItem.isHour) {
        day = day * 60;
      }
      const hours = (day % 1) * 24;
      const minutes = (hours % 1) * 60;
      return `${Math.floor(day)}天${Math.floor(hours)}时${Math.floor(minutes)}分`;
    },
  },
};
</script>
<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    background-color: rgba(255, 255, 0, 0.3);
  }

  100% {
    background-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}

@keyframes breathee-error {
  0% {
    background-color: rgba(255, 0, 0, 0.2);
  }

  100% {
    background-color: rgba(255, 0, 0, 0.5);
    // background: rgba(255, 255, 255, 0.7);
  }
}

.switch-status {
  height: 42px;
  display: flex;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.6);
  padding: 0 10px !important;
  box-sizing: border-box;
  width: 100%;
  align-items: center;
}

.warning-flag {
  background-color: #f7f910;
  animation: breathee-warning 1500ms infinite alternate ease-in-out;
}

.error-flag {
  background-color: #ff0000;
  animation: breathee-error 1500ms infinite alternate ease-in-out;
}

.value-span {
  margin-left: 5px;
}
</style>
